import isValidBuyAmount from "./../validations/is.valid.buy.amount";

export default (values, value, type) => isValidBuyAmount(value);
